<template>
    <div class="category">
        <h3>{{ title }}</h3>
        <p class="text-sm">{{ description }}</p>
        <div class="cards">
            <slot></slot>
            <card :title="t('settings-connections-request_connection')"
             :description="t('settings-connections-request_connection_description')"
             @click="openWhatsAppRequest">
                <template #icon>
                    <Icon icon-class="ui-plus" size="5" />
                </template>
            </card>
        </div>
    </div>
</template>
<script>
import Card from "./card.vue";
export default {
    components: { Card },
    name: "category",
    props: {
        title: {
            type: String,
            required: true,
        },
        description: {
            type: String,
            required: true,
        },
    },
    methods: {
        openWhatsAppRequest() {
            const message = encodeURIComponent(`${this.t('settings-connections-request_message_prefix')} ${this.title}`);
            const phone = "5548988418958";
            window.open(`https://wa.me/${phone}?text=${message}`, '_blank');
        }
    }
}
</script>
<style lang="scss" scoped>
.category {
    display: flex;
    flex-direction: column;
    gap: 10px;
    width: 100%;
    flex-grow: 1;
    h3 {
        color: var(--Black-700, #384250);
        margin-bottom: 0;
    }
    p {
        color: var(--Black-500, #6C737F);
    }   
    .cards {
        width: 100%;
        display: grid;
        grid-template-columns: 1fr 1fr 1fr 1fr;
        gap: 10px;
    }
    @media (max-width: 1600px) {
        .cards {
            grid-template-columns: 1fr 1fr 1fr;
        }
    }
    @media (max-width: 1200px) {
        .cards {
            grid-template-columns: 1fr 1fr;
        }
    }
    @media (max-width: 768px) {
        .cards {
            grid-template-columns: 1fr;
        }
    }
}
</style>